export const clubWebUrl = (url, params = {}) => {
    const entries = Object.entries(params);
    return `${url}${url.includes("?") || !entries.length ? "" : "?"}${entries
        .filter(([, value]) => Boolean(value) || Number(value) === 0)
        .map(([key, value]) => `${key}=${encodeURIComponent(value || "")}`)
        .join("&")}`;
};
//# sourceMappingURL=clubWebUrl.js.map